import { Col, Divider, Row } from "antd";
import { InputNumber, Select, Switch, TimePicker } from "components/form";
import { ACTION } from "features/payment/schemas/PaymentShemas";
import { useTranslation } from "react-i18next";
import styles from "../styles/Attendance.module.css";
import CheckInChanelCards from "./CheckInChanelCards";

const ShiftsOtherSettingForm = ({ values = {}, checkInChanelOptions = [] }) => {
  const { t, i18n } = useTranslation();
  let disabledContent = values?.type === ACTION.VIEW ? true : false;
  return (
    <>
      <Row justify="space-between" style={{ paddingTop: "24px" }}>
        <b className={styles.infoTopic}>{t('othersetting.other-setting')}</b>
      </Row>
      <Divider />
      <div className="card" style={{ marginTop: "24px" }}>
        <Switch
          name="preShiftOtPeriod"
          label={
            <>
              <b className={styles.switchLabel}>
                {t('othersetting.set-pre-shift-overtime-period')}
              </b>
              <br />
              {t('othersetting.pre-shift-overtime-ot2-will-be-calculated-automatically-if-requested-after-set-hours')}
            </>
          }
          disabled={disabledContent}
        />
        <Divider />
        {values.preShiftOtPeriod ? (
          <Row gutter={[24, 16]}>
            <Col span={12}>
              <TimePicker
                name="requestOtAfter"
                label={t('othersetting.request-ot-after')}
                size="large"
                // format={i18n.language === "en" ? `HH:mm` : `HH:mm`}
                disabled={disabledContent}
              />
            </Col>
          </Row>
        ) : (
          <div></div>
        )}
      </div>
      <div className="card" style={{ marginTop: "24px" }}>
        <Switch
          name="calculateOtAuto"
          label={
            <>
              <b className={styles.switchLabel}>
                {t('othersetting.calculate-overtime-automatically')}
              </b>
              <br />
              {t('othersetting.overtime-document-will-be-created-automatically-after-completing-working-hours')}
            </>
          }
          disabled={disabledContent}
        />
        <Divider />
        {values.calculateOtAuto ? (
          <Row gutter={[24, 16]}>
            <Col span={24}>
              <CheckInChanelCards
                name="checkInChanelId"
                options={checkInChanelOptions}
                disabled={disabledContent}
              />
            </Col>
            <Col span={12}>
              <InputNumber
                name="beforeOtAutoCalculate"
                label={t('othersetting.before-ot-auto-calculation')}
                placeholder={t('othersetting.minutes')}
                size="large"
                step={15}
                textAlign="left"
                disabled={disabledContent}
              />
            </Col>
            <Col span={12}>
              <InputNumber
                name="afterOtAutoCalculate"
                label={t('othersetting.after-ot-auto-calculation')}
                placeholder={t('othersetting.minutes')}
                size="large"
                step={15}
                textAlign="left"
                disabled={disabledContent}
              />
            </Col>
          </Row>
        ) : (
          <div></div>
        )}
      </div>
      <div className="card" style={{ marginTop: "24px" }}>
        <Switch
          name="openAllowanceTab"
          label={
            <>
              <b className={styles.switchLabel}>{t('othersetting.open-allowance-tab')}</b>
              <br />
              {t('othersetting.shift-document-will-be-created-automatically-according-to-specific-conditions')}
            </>
          }
          disabled={disabledContent}
        />
        <Divider />
        {values.openAllowanceTab ? (
          <Row gutter={[24, 16]}>
            <Col span={12}>
              <InputNumber
                name="allowancePay"
                label={t('othersetting.allowance-pay')}
                placeholder={t('othersetting.baht')}
                size="large"
                textAlign="end"
                disabled={disabledContent}
              />
            </Col>
            <Col span={12} />
            <Col span={12}>
              <Switch label={t('othersetting.special-shift-from-ot')} name="specialShiftFromOt" />
            </Col>
            <Col span={12} />
            {values.specialShiftFromOt ? (
              <>
                <Col span={12}>
                  <InputNumber
                    name="completeWorkInFromOt"
                    label={t('othersetting.complete-work-in')}
                    placeholder={t('othersetting.hours')}
                    size="large"
                    step={0.5}
                    textAlign="left"
                    disabled={disabledContent}
                  />
                </Col>
                <Col span={12}>
                  <InputNumber
                    name="willBePaidFromOt"
                    label={t('othersetting.will-be-paid')}
                    placeholder={t('othersetting.baht')}
                    size="large"
                    step={50}
                    textAlign="right"
                    disabled={disabledContent}
                  />
                </Col>
                <Divider />
              </>
            ) : (
              <></>
            )}
            <Col span={12}>
              <Switch
                name="specialShiftFromHoliday"
                label={t('othersetting.special-shift-from-holiday')}
                disabled={disabledContent}
              />
            </Col>
            <Col span={12} />
            {values.specialShiftFromHoliday ? (
              <>
                <Col span={12}>
                  <InputNumber
                    name="allowancePay"
                    label={t('othersetting.allowance-pay')}
                    placeholder={t('othersetting.baht')}
                    size="large"
                    textAlign="end"
                    disabled={disabledContent}
                  />
                </Col>
                <Col span={12}></Col>
                <Divider />
              </>
            ) : (
              <></>
            )}
            <Col span={12}>
              <Switch name="workTimeAllowance" label={t('othersetting.work-time-allowance')} />
            </Col>
            <Col span={12} />
            {values.workTimeAllowance ? (
              <>
                <Col span={12}>
                  <InputNumber
                    name="completeWorkInWorkTime"
                    label={t('othersetting.complete-work-in')}
                    placeholder={t('othersetting.minutes')}
                    size="large"
                    step={10}
                    textAlign="left"
                    disabled={disabledContent}
                  />
                </Col>
                <Col span={12}>
                  <InputNumber
                    name="willBePaidWorkTime"
                    label={t('othersetting.will-be-paid')}
                    placeholder={t('othersetting.baht')}
                    size="large"
                    step={50}
                    disabled={disabledContent}
                  />
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
        ) : (
          <></>
        )}
      </div>
      <div className="card" style={{ marginTop: "24px" }}>
        <Switch
          name="lateStatusDuringBreaksCalculation"
          label={
            <>
              <b className={styles.switchLabel}>
                {t('othersetting.late-status-during-breaks-calculation')}
              </b>
              <br />
              {t('othersetting.set-a-stamp-in-and-stamp-out-period-to-calculate-employees-late-status-during-breaks')}
            </>
          }
          disabled={disabledContent}
        />
        <Divider />
        {values.lateStatusDuringBreaksCalculation ? (
          <Row gutter={[24, 16]}>
            <Col span={12}>
              <InputNumber
                name="allowedToStampOutBefore"
                label={t('othersetting.allowed-to-stamp-out-before-break-starts-by')}
                placeholder={t('othersetting.minutes')}
                size="large"
                textAlign="left"
                disabled={disabledContent}
              />
            </Col>
            <Col span={12}>
              <InputNumber
                name="mustStampOutAfter"
                label={t('othersetting.must-stamp-out-after-break-starts-by')}
                placeholder={t('othersetting.minutes')}
                size="large"
                textAlign="left"
                disabled={disabledContent}
              />
            </Col>
            <Col span={12}>
              <InputNumber
                name="allowedToStampInBefore"
                label={t('othersetting.allowed-to-stamp-in-before-break-starts-by')}
                placeholder={t('othersetting.minutes')}
                size="large"
                textAlign="left"
                disabled={disabledContent}
              />
            </Col>
            <Col span={12}>
              <InputNumber
                name="mustStampInAfter"
                label={t('othersetting.must-stamp-out-after-break-ends-by')}
                placeholder={t('othersetting.minutes')}
                size="large"
                textAlign="left"
                disabled={disabledContent}
              />
            </Col>
          </Row>
        ) : (
          <div></div>
        )}
      </div>
    </>
  );
};

export default ShiftsOtherSettingForm;
